<template>
  <v-dialog
    v-model="dialogIsOpen"
    max-width="300"
    :persistent="true"
  >
    <v-card class="dialog-box home-form-container">
      <h4 style="text-align: justify;">{{ $t('DeleteFiberTubeWarning') }}</h4>

      <v-card-actions class="form-buttons" style="padding: 8px 0;">
        <v-btn @click="cancelDelete" :ripple="false" class="secondary-button" text>
          {{ $t("No") }}
        </v-btn>
        <v-btn @click="confirmDelete" :ripple="false" class="main-button" text>
          {{ $t("Yes") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteTubeFiberDialog",

  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    },
  },

  methods: {
    cancelDelete() {
      this.$emit('cancel-delete');
    },

    confirmDelete() {
      this.$emit('confirm-delete');
    },
  }
}
</script>

<style scoped>
.dialog-box {
  padding: 15px 15px;
  border-radius: 8px;
}

.v-dailog {
  padding: 8px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/forms/DeleteTubeFiberDialog.vue